// extracted by mini-css-extract-plugin
module.exports = {"headerImg":"_3hYbfkwX-Sh8sPi1czaGwt"};